<div class="modal-header">
  <h4 class="modal-title">Are you sure?</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
  </button>
</div>
<div class="modal-body">
  <p>
    We understand losing a pet is extremely distressing.
  </p>
  <p>
    If <strong>{{ petName }}</strong> has passed away, please confirm so we don't unnecessarily contact you in future.
  </p>

  <div *ngIf="!userHasBasicAccount && isLastPetAlive">
    <p>
      You have an ongoing <strong>{{ currentUserPlan }}</strong> plan, do you want to keep this cover on your account?
    </p>
    <p>
      Please note, cancelling the subscription now will remove any cover for future pets added to your account.
    </p>
    <p>
      To cancel, please tick this box
      <mat-checkbox 
        class="mat-checkbox"
        color="primary"
        [(ngModel)]="isSubscriptionCancellationRequested">
      </mat-checkbox>
    </p>
  </div>

</div>
<div class="modal-footer">
  <button *ngIf="userHasBasicAccount || !isLastPetAlive" type="button" class="btn btn-danger" ngbAutofocus (click)="activeModal.dismiss()">
    Cancel
  </button>
  <button type="button" class="btn btn-success" (click)="activeModal.close(isSubscriptionCancellationRequested)">
    Confirm
  </button>
</div>
